import { Alert, Grid, TextField } from '@mui/material'
import React, { useContext } from 'react'

import { formatCode } from 'components/common/CodeBlock'
import { ObservabilityToolAuthenticationContext } from 'context/status-checks/ObservabilityToolAuthenticationContext'
import { useTranslation } from 'hooks/use-translation'

export const ObservabilityToolAuthenticationStatus: React.FC<{
  isLoading: boolean
}> = ({ isLoading }) => {
  const { trans } = useTranslation()
  const { authenticationResponse } = useContext(
    ObservabilityToolAuthenticationContext
  )
  const { alertSeverity, httpStatusCode, responseBody, message } =
    authenticationResponse

  if (!alertSeverity) {
    return null
  }

  const isBodyContentTypeHtml =
    authenticationResponse?.contentType?.includes('html')

  return (
    <Grid
      container
      data-test-test-status-check-integration
      direction="column"
      rowSpacing={2}
    >
      {!isLoading && alertSeverity && (
        <Grid item>
          <Alert
            data-testid="test-status-check-integration-alert"
            severity={alertSeverity}
          >
            {message}
          </Alert>
        </Grid>
      )}
      {!isLoading && Boolean(httpStatusCode) && alertSeverity === 'error' && (
        <Grid item>
          <TextField
            contentEditable={false}
            data-testid="test-status-check-integration-response-code"
            disabled={true}
            fullWidth={true}
            InputProps={{ sx: { fontFamily: 'Monaco' } }}
            label={trans('status_checks.authentication.status.response_code')}
            sx={{ fontFamily: 'Sohne Mono' }}
            value={httpStatusCode}
          />
        </Grid>
      )}
      {!isLoading &&
        Boolean(responseBody) &&
        !isBodyContentTypeHtml &&
        alertSeverity === 'error' && (
          <Grid item>
            <TextField
              multiline
              contentEditable={false}
              data-testid="test-status-check-integration-response-body"
              disabled={true}
              fullWidth={true}
              InputProps={{ sx: { fontFamily: 'Monaco' } }}
              label={trans('status_checks.authentication.status.response_body')}
              maxRows={8}
              sx={{ fontFamily: 'Sohne Mono' }}
              value={formatCode(null, responseBody)}
            />
          </Grid>
        )}
    </Grid>
  )
}
